import InvoicingFormSend from './InvoicingFormSend';

export default InvoicingFormSend;
